import CaptureBackPrompt from 'features/rdc/screens/CaptureBackPrompt/CaptureBackPrompt';
import React from 'react';

export default function Page() {
  return <CaptureBackPrompt />;
}
